import {
  withTranslation,
} from 'react-i18next';

import ProfileInvoiceFieldsView from './ProfileInvoiceFieldsView';

const TranslatedComponent = withTranslation()(ProfileInvoiceFieldsView);

const Component = TranslatedComponent;

export default Component;
